/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Parametry wyszukiwania
 */
export interface SearchData { 
    numPerPage?: number;
    currentPage?: number;
    type?: SearchData.TypeEnum;
    authorId?: number;
    portalId?: number;
    lang?: string;
    phrase?: string;
    hasPdfContent?: boolean;
    hasHtmlContent?: boolean;
    hasReferences?: boolean;
    hasAbstract?: boolean;
    searchSort?: SearchData.SearchSortEnum;
    languages?: Array<string>;
    searchByTypes?: Array<SearchData.SearchByTypesEnum>;
}
export namespace SearchData {
    export type TypeEnum = 'TITLE' | 'ABSTRACT' | 'KEYWORDS' | 'AUTHORS' | 'HTML_CONTENT';
    export const TypeEnum = {
        TITLE: 'TITLE' as TypeEnum,
        ABSTRACT: 'ABSTRACT' as TypeEnum,
        KEYWORDS: 'KEYWORDS' as TypeEnum,
        AUTHORS: 'AUTHORS' as TypeEnum,
        HTML_CONTENT: 'HTML_CONTENT' as TypeEnum
    };
    export type SearchSortEnum = 'RATING' | 'PUBL_DATE_DESC' | 'PUBL_DATE_ASC' | 'TITLE_ASC' | 'TITLE_DESC';
    export const SearchSortEnum = {
        RATING: 'RATING' as SearchSortEnum,
        PUBL_DATE_DESC: 'PUBL_DATE_DESC' as SearchSortEnum,
        PUBL_DATE_ASC: 'PUBL_DATE_ASC' as SearchSortEnum,
        TITLE_ASC: 'TITLE_ASC' as SearchSortEnum,
        TITLE_DESC: 'TITLE_DESC' as SearchSortEnum
    };
    export type SearchByTypesEnum = 'TITLE' | 'ABSTRACT' | 'KEYWORDS' | 'AUTHORS' | 'HTML_CONTENT';
    export const SearchByTypesEnum = {
        TITLE: 'TITLE' as SearchByTypesEnum,
        ABSTRACT: 'ABSTRACT' as SearchByTypesEnum,
        KEYWORDS: 'KEYWORDS' as SearchByTypesEnum,
        AUTHORS: 'AUTHORS' as SearchByTypesEnum,
        HTML_CONTENT: 'HTML_CONTENT' as SearchByTypesEnum
    };
}


